import { getRecordLink, HS_OBJECT_ID, LINKS } from './links-mapping';
import { hasObjectTypeId } from '../../utils/source-utils';
// @ts-expect-error migrate upstream file
import { isCustomObjectType } from 'reporting-data/lib/customObjects';
export const getLinkProvider = (snowflakeTable, snowflakeProperty) => {
  if (!hasObjectTypeId(snowflakeTable) || !snowflakeProperty) {
    return undefined;
  }
  const {
    objectTypeId
  } = snowflakeTable;
  const {
    name
  } = snowflakeProperty;
  if (isCustomObjectType(objectTypeId) && name === HS_OBJECT_ID) {
    return id => getRecordLink(objectTypeId, id);
  }
  const getLink = LINKS.getIn([objectTypeId, name]);
  if (!getLink) {
    return undefined;
  }
  return id => getLink(objectTypeId, id);
};